import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'ruleset',
    path: 'max_discount.percentage_base',
    viewPath: props.viewPath,
  })
  let selected = useDataValue({
    context: 'ruleset',
    path: 'max_discount.percentage_base',
    viewPath: props.viewPath,
  })
  let baseId = useDataValue({
    context: 'base',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onChange() {
    if (baseId === selected) return
    change(baseId)
  }
}
